/** Centralized user-facing messages (success, error, confirmations, empty states). */

export const MESSAGES = {
  GENERIC: {
    UNEXPECTED_ERROR: 'Something went wrong. Please try again.',
    NETWORK_ERROR: 'Unable to reach the server. Check your connection.',
    SESSION_EXPIRED: 'Your session has expired. Please sign in again.',
    FORBIDDEN: 'You do not have permission to perform this action.',
    NOT_FOUND: 'The requested resource could not be found.',
    SERVER_ERROR: 'A server error occurred. Our team has been notified.',
  },
  AUTH: {
    LOGIN_SUCCESS: 'Welcome back!',
    LOGIN_FAILED: 'Invalid phone number or password.',
    LOGOUT_SUCCESS: 'You have been signed out.',
  },
  PIPELINE: {
    APPROVED: 'Article approved and moved to Stage 2.',
    REJECTED: 'Article rejected.',
    ROUTED: 'Article routed successfully.',
    UPLOAD_QUEUED: 'Upload queued for extraction.',
    DECISION_SAVED: 'Storage decision saved.',
    DISPATCHED: 'Dispatch requested.',
    SCHEDULE_SAVED: 'Briefing schedule saved.',
  },
  CRUD: {
    CREATE_SUCCESS: 'Created successfully.',
    UPDATE_SUCCESS: 'Updated successfully.',
    DELETE_SUCCESS: 'Deleted successfully.',
    SAVE_FAILED: 'Could not save changes.',
  },
  CONFIRM: {
    DELETE_TITLE: 'Delete confirmation',
    DELETE_BODY: 'This action cannot be undone. Are you sure you want to continue?',
  },
  EMPTY: {
    NO_DATA: 'No data to display yet.',
    NO_RESULTS: 'No results match your filters.',
  },
};

export default MESSAGES;
